const colors = {
  primary: '#98c0e4', // Color for buttons or links
  bg: '#494f5c', // Background color
  white: '#fff',
  grey: {
    dark: 'rgba(0, 0, 0, 0.9)',
    default: '#c6cdda',
    light: 'rgba(0, 0, 0, 0.5)',
    ultraLight: 'rgba(0, 0, 0, 0.25)',
  },
  link: '#98c0e4',
}

const transitions = {
  normal: '0.5s',
}

const fontSize = {
  small: '0.9rem',
  big: '1.9rem',
}

export default {
  colors,
  transitions,
  fontSize,
}
